<template>
  <div class="login-container">
    <b-card>
      <div class="logo-wrapper">
        <img :src="logo" alt="" />
      </div>
      <h5 style="color: #ffffff" class="mb-5">Continue with Email</h5>
      <!--      <div class="title-wrapper">
              <h4>Login</h4>
            </div>-->
      <b-form>
        <div class="input-wrapper mb-2">
          <label for="email">Email</label>
          <input
            v-model="formData.email"
            id="email"
            placeholder="Enter your email"
            autocomplete="off"
          />
          <div
            class="form-group__message"
            v-if="!$v.formData.email.required && $v.formData.email.$error"
          >
            Field is required
          </div>
          <div
            class="form-group__message"
            v-if="$v.formData.email.required && $v.formData.email.$invalid"
          >
            Enter valid email
          </div>
        </div>
        <div class="input-wrapper mb-2">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            v-model="formData.password"
            placeholder="Enter your password"
            autocomplete="off"
          />
          <div
            class="form-group__message"
            v-if="!$v.formData.password.required && $v.formData.password.$error"
          >
            Field is required
          </div>
        </div>
        <div class="text-center">
          <div class="mb-1">
            <router-link
              style="color: #fff; font-size: 13px"
              to="/forgot-password"
            >
              Forgot Password
            </router-link>
          </div>
          <div class="mb-3">
            <router-link style="color: #fff; font-size: 13px" to="/register">
              Register
            </router-link>
          </div>
          <b-btn class="btn-yellow" @click.prevent="submit">Login</b-btn>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import appLogo from "@/assets/img/logo.svg";
import { email, required } from "vuelidate/lib/validators";

export default {
  name: "Login",
  props: ["modelValue"],
  emits: ["update:modelValue"],
  data() {
    return {
      logo: appLogo,
      formData: {
        email: "",
        password: "",
      },
    };
  },
  validations: {
    formData: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    submit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        this.$store
          .dispatch("auth/login", this.formData)
          .then(() => {
            console.log("** logged in successfully **");
            this.$store
              .dispatch("auth/getOwnProfile")
              .then((_) => {
                console.log(_);
                const redirects = this.$store.state.redirects;
                if (redirects !== null) {
                  this.$store.commit("setRedirect", null);
                  return this.$router.push(redirects);
                }
                if (_.role === "admin") {
                  return this.$router.push("/admin");
                }
                this.$router.push("/progress");
              })
              .catch(() => {
                this.$store.dispatch("auth/logout");
              });
            // this.$emit('closeModal')
          })
          .catch((e) => {
            this.$notify({
              type: "error",
              title: "Error",
              text: "Username or password doesnot match.",
            });
            console.log("err => ", e);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;

  .logo-wrapper {
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 65px;
      width: 65px;
    }
  }
  .card {
    background-color: transparent;
    border-color: transparent;
  }

  .input-wrapper {
    position: relative;
    label {
      position: absolute;
      font-size: 13px;
      font-weight: lighter;
      top: -5px;
      left: 10px;
      color: #fff;
    }
    input {
      padding: 8px 10px;
      font-weight: lighter;
      color: #ffffff;
      margin-bottom: 20px;
      background-color: transparent !important;
      border-color: transparent !important;
      border-bottom: 1px solid #ffffff !important;
      outline: none;

      &::placeholder {
        font-weight: lighter;
        font-size: 11px;
        color: lightblue;
      }
    }
  }

  .btn-yellow {
    background: #f1bc04;
    border-color: #f1bc04;
    border-radius: 45px;
    color: #000000;
    width: 145px;
    height: 40px;
    line-height: 21px;
    letter-spacing: 0.05em;
  }
}
</style>
